export function shouldContinueAfterInviteAcceptError(error: { message?: string; status?: string | number; code?: string } | null | undefined): boolean {
  const status = typeof error?.status === 'string' ? error.status.toLowerCase() : '';
  const code = typeof error?.code === 'string' ? error.code.toLowerCase() : '';
  const message = typeof error?.message === 'string' ? error.message.toLowerCase() : '';
  return status === 'invitation_not_found'
    || code === 'invitation_not_found'
    || message.includes('invitation not found')
    || message.includes('no invitation found');
}

export function shouldWaitForAuthorizationClick(): boolean {
  return true;
}

interface InvitationAuthorizationStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

const PENDING_INVITATION_AUTHORIZATION_KEY = 'oracord.pendingInvitationAuthorizationId';

export function markPendingInvitationAuthorization(storage: InvitationAuthorizationStorage, invitationId: string): void {
  if (!invitationId) return;
  storage.setItem(PENDING_INVITATION_AUTHORIZATION_KEY, invitationId);
}

export function consumePendingInvitationAuthorization(storage: InvitationAuthorizationStorage, invitationId: string): boolean {
  if (!invitationId) return false;
  if (storage.getItem(PENDING_INVITATION_AUTHORIZATION_KEY) !== invitationId) return false;
  storage.removeItem(PENDING_INVITATION_AUTHORIZATION_KEY);
  return true;
}
